var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignmentCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4576_70617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3951 0H3.60494C1.61399 0 0 2.10751 0 4.70726V19.2927C0 21.8925 1.61399 24 3.60494 24H36.3951C38.386 24 40 21.8925 40 19.2927V4.70726C40 2.10751 38.386 0 36.3951 0Z",
    fill: "#265183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7616 3.68359H6.23887C4.62969 3.68359 3.3252 5.38698 3.3252 7.48821V16.5074C3.3252 18.6086 4.62969 20.312 6.23887 20.312H33.7616C35.3707 20.312 36.6752 18.6086 36.6752 16.5074V7.48821C36.6752 5.38698 35.3707 3.68359 33.7616 3.68359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7315 6H17.2685C14.9111 6 13 7.70339 13 9.80462V14.674C13 16.7752 14.9111 18.4786 17.2685 18.4786H22.7315C25.0889 18.4786 27 16.7752 27 14.674V9.80462C27 7.70339 25.0889 6 22.7315 6Z",
    fill: "#265183"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4576_70617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentCenter);
export default __webpack_public_path__ + "static/media/alignment-center.86f22b6650d0655b718a9211e7155591.svg";
export { ForwardRef as ReactComponent };